import { memo } from 'react';

import { SearchIcon } from '@air/design-icons';

export type WorkspaceAgentActionsMenuEmptyStateProps = {
  message: string;
};

export const WorkspaceAgentActionsMenuEmptyState = memo(({ message }: WorkspaceAgentActionsMenuEmptyStateProps) => {
  return (
    <div
      aria-live="polite"
      className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2 ads:text-metadata text-gray-10"
      data-testid="WORKSPACE_AGENT_ACTIONS_MENU_EMPTY"
      role="status"
    >
      <SearchIcon aria-hidden className="size-8 shrink-0 ads:text-icon-default" />
      <p className="text-12 leading-4">{message}</p>
    </div>
  );
});

WorkspaceAgentActionsMenuEmptyState.displayName = 'WorkspaceAgentActionsMenuEmptyState';
